import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../grid/reduxStore/Store';
import { selectAllVariables } from '../grid/reduxStore/allVariableSlice';
import AutocompleteVariables from './AutocompleteVariables';
import { useVariableNavigation } from './useVariableNavigation';
import VariableBreadcrumbs from './VariableBreadcrumbs';
import VariableFolders from './VariableFolders';

const VariableSearchPanel = ({ isEditor = false, query }: { isEditor?: boolean; query?: string }) => {
  const { t } = useTranslation();
  const variables = useAppSelector(selectAllVariables);
  const { activeNode, breadcrumbs, selectNode, initialLoad } = useVariableNavigation(variables);
  const [autoCompleteValue, setAutoCompleteValue] = useState<string>('');
  const [isFreeSoloActive, setIsFreeSoloActive] = useState(true);

  useEffect(() => {
    if (query !== undefined) setAutoCompleteValue(query);
  }, [query]);

  const popUpStyle = isEditor
    ? {
        height: '215px',
        width: '280px',
        boxShadow: '0 5px 5px -3px rgba(0, 0, 0, 0.20), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)',
        padding: '8px 0',
        borderRadius: '4px',
        backgroundColor: '#fff',
        overflow: 'hidden',
      }
    : {};

  return variables?.variables ? (
    <Box sx={popUpStyle}>
      <AutocompleteVariables
        setIsFreeSoloActive={setIsFreeSoloActive}
        isEditor={isEditor}
        variables={variables}
        autoCompleteValue={autoCompleteValue}
        setAutoCompleteValue={setAutoCompleteValue}
        externalInputValue={isEditor ? autoCompleteValue : undefined}
        slotProps={{
          popper: {
            placement: 'bottom-start',
            disablePortal: true,
            sx: { zIndex: 'auto', width: '100%' },
            modifiers: [
              {
                name: 'flip',
                enabled: false,
              },
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  boundary: 'viewport',
                },
              },
            ],
          },
          paper: {
            sx: {
              boxShadow: 'none',
              border: 'none',
              outline: 'none',
              '.MuiAutocomplete-listbox': { maxHeight: isEditor ? '178px' : '235px' },
            },
          },
        }}
      />
      {!isFreeSoloActive && (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <SearchIcon sx={{ color: 'text.secondary', fontSize: '1.5rem' }} />
          <Typography variant="body1" sx={{ fontSize: '12px', color: 'text.secondary', mb: 0.5 }}>
            {t('editor.variables.no_variables')}
          </Typography>
        </Box>
      )}
      {!autoCompleteValue && (
        <>
          {!initialLoad && <VariableBreadcrumbs isEditor={isEditor} breadcrumbs={breadcrumbs} selectNode={selectNode} />}
          <VariableFolders isEditor={isEditor} activeNode={activeNode || variables.variables} selectNode={selectNode} />
        </>
      )}
    </Box>
  ) : null;
};

export default VariableSearchPanel;
